<template>
  <div class="content">
    <base-header :choose-index="4"></base-header>
    <div class="middle_content">
      <div class="middle_content-border">
        <div class="middle_content-menu-bg" v-bgImg="require('@@/assets/img/westa/activity/ship_bg.png')"></div>
        <div class="middle_content-menu">
          <div class="middle_content-menu-list">
            <div class="middle_content-menu-list-text1">长帝美食视频:</div>
            <div class="middle_content-menu-list-flex">
              <a :href="'/baking?id=' + item.category_id" class="middle_content-menu-list-text2" :class="{ 'active': item.category_id === id }" v-for="item in website_video_categories" :key="item.category_id">
                <div>{{ item.category_title }}</div>
              </a>
            </div>
          </div>
        </div>
        <div class="middle_content-line">
          <div class="middle_content-line-line1"></div>
        </div>
        <div class="middle_content-post">
          <div class="middle_content-post-content">
            <div class="middle_content-post-pic" v-bgImg="utils.getQiniuWidthUrl(website_video_category.category_face, 240, 2, 'webp')"></div>
            <div class="middle_content-post-right">
              <div class="middle_content-post-right-text1">{{ website_video_category.category_title }}</div>
              <div class="middle_content-post-right-text2">{{ website_video_category.category_sub_title }}</div>
              <div class="middle_content-post-right-text3">共{{ total }}集</div>
            </div>
          </div>
        </div>
      </div>
      <div class="middle_content-classify">
        <!-- <div class="middle_content-classify-text">视频</div> -->
        <el-row :gutter="18">
          <el-col :span="6" class="middle_content-classify-col" v-for="item in website_videos" :key="item.video_id">
            <div class="test">
              <div class="middle_content-classify-col-img transform_scale_1_1" v-bgImg="utils.getQiniuWidthUrl(item.video_face, 284, 2, 'webp')" @click="showVideo(item.video_url)"></div>
            </div>
            <div class="middle_content-classify-col-down">
              <div class="middle_content-classify-col-down-title">{{ item.video_title }}</div>
              <div class="middle_content-classify-col-down-time">
                标签：
                <span class="middle_content-classify-col-down-time-text">{{ item.video_sub_title }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- <div class="news_pagination">
          <el-pagination
            layout="prev, pager, next"
            background
            @current-change="getWebsiteVideos"
            :current-page.sycn="page"
            :total="total"
          ></el-pagination>
        </div>-->
      </div>
    </div>

    <el-dialog :visible.sync="centerDialogVisible" width="880px" center>
      <!-- <div class="dialog"> -->
      <div>
        <video v-if="centerDialogVisible" ref="video" width="830" height="440" controls="controls" autoplay="autoplay">
          <source :src="video_link" type="video/mp4" />
        </video>
      </div>
      <!-- </div> -->
      <!-- <iframe frameborder="0" :src="video_link" allowfullscreen="true" class="dialog-video"></iframe> -->
    </el-dialog>
    <base-footer></base-footer>
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
export default {
  data() {
    return {
      id: "0",
      centerDialogVisible: false,
      website_video_categories: [],
      website_video_category: {},
      website_videos: [],
      total: 0,
      page: 1,
      video_link: ""
    };
  },
  components: {
    BaseHeader,
    BaseFooter
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      let id = this.$route.query.id;
      this.id = id;
      this.getWebsiteVideos();
    }
  },
  created() {
    let id = this.$route.query.id;
    this.id = id;
    console.log(id);
    this.getWebsiteVideoCategories();
    this.getWebsiteVideos();
  },
  methods: {
    toPath1(path, index) {
      this.$router.push({
        path: path,
        query: {
          id: index
        }
      });
    },
    getWebsiteVideoCategories() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteVideoCategory_getWebsiteVideoCategories,
          this.qs.stringify(params)
        )
        .then(result => {
          this.website_video_categories = result.website_video_categories;
        })
        .catch(error => { });
    },
    getWebsiteVideos(page) {
      if (page != null) {
        this.page = page;
      }
      let params = {
        page: 0,
        page_count: 800,
        video_website_video_category_id: this.id
      };
      this.req
        .get(
          url_api_web_websiteVideo_getWebsiteVideos,
          this.qs.stringify(params)
        )
        .then(result => {
          this.website_video_category = result.website_video_category;
          this.total = result.total;
          this.website_videos = result.website_videos;
        })
        .catch(error => { });
    },
    showVideo(link) {
      this.centerDialogVisible = true;

      this.video_link =
        "http://qiniu.changdi-tech.com/" + link + "?avvod/m3u8/s/1280x720";
      if (this.$refs.video) {
        this.$refs.video.src = this.video_link;
      }
      console.log(this.$refs.video);
    }
  }
};
</script>

<style lang="less" scoped>
.middle_content {
  padding-top: 64px;
  background: #f2f2f2;
  min-width: 1200px;

  &-border {
    // width: 1200px;
    // margin: 0 auto;
    // box-shadow: 0 2px 6px 0 rgba(24, 31, 153, 0.06);
  }

  &-menu {
    width: 1200px;
    margin: 0 auto;
    margin-top: -300px;
    // height: 68px;
    background: #f2f2f2;
    // border-bottom: 1px solid #e8e8e8;
    // padding: 20px 0;
    background: #fff;

    &-bg {
      width: 1600px;
      height: 330px;
      margin: 0 auto;
    }

    &-list {
      width: 1200px;
      background: #fff;
      height: 80px;
      margin: 0 auto;
      display: flex;
      align-items: flex-end;
      font-size: 16px;
      padding: 0 20px;
      box-sizing: border-box;

      &-flex {
        display: -webkit-box;
        width: 1080px;
        overflow-x: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        display: flex;
      }

      &-text1 {
        color: #666;
        // margin-right: 36px;
        width: 120px;
        height: 64px;
        line-height: 64px;
      }

      &-text2 {
        height: 64px;
        line-height: 64px;
        color: #333;
        // margin-right: 36px;
        cursor: pointer;
        padding: 0 20px;
      }
    }
  }

  &-line {
    width: 1200px;
    height: 2px;
    background: #fff;
    margin: 0 auto;

    &-line1 {
      width: 1200px;
      height: 2px;
      // margin-left: 20px;
      background: #181f99;
    }
  }

  &-post {
    width: 1200px;
    background: #f2f2f2;
    margin: 0 auto;
    // padding-top: 8px;
    // padding-bottom: 8px;

    &-content {
      width: 1200px;
      background: #fff;
      margin: 0 auto;
      display: flex;
      padding: 20px;
      // padding-bottom: 20px;
      box-sizing: border-box;
    }

    &-pic {
      width: 146px;
      height: 146px;
      // margin-top: 8px;
    }

    &-right {
      margin-left: 20px;
      font-size: 20px;
      color: #333;

      &-text1 {
        font-size: 30px;
        // margin-top: 8px;
        margin-bottom: 20px;
        font-weight: bold;
      }

      &-text3 {
        color: #999;
        margin-top: 20px;
      }
    }
  }

  &-title {
    width: 100%;
    font-size: 46px;
    line-height: 198px;
    display: flex;
    justify-content: center;
    align-items: center;

    &-icon {
      width: 80px;
      height: 80px;
      margin-right: 30px;
    }
  }

  &-classify {
    width: 1200px;
    margin: 40px auto;

    &-text {
      font-size: 24px;
      color: #333;
      margin-bottom: 36px;
    }

    &-col {
      margin-bottom: 60px;

      &-img {
        width: 284px;
        height: 160px;
      }

      &-down {
        // display: flex;
        // justify-content: space-between;
        // align-items: center;]
        width: 284px;
        background: #fff;
        font-size: 16px;
        color: #333;
        padding: 18px 10px;
        box-sizing: border-box;

        &-title {
          cursor: pointer;
        }

        &-time {
          color: #666;
          font-size: 14px;
          margin-top: 16px;

          &-text {
            height: 24px;
            line-height: 24px;
            padding: 0 10px;
            font-size: 14px;
            color: #181f99;

            background: rgba(24, 31, 153, 0.1);
          }
        }
      }
    }
  }

  &-text {
    font-size: 36px;
    text-align: center;
  }

  &-down {
    width: 1200px;
    margin: 44px auto;

    &-col {
      width: 286px;
      height: 88px;
      background: #faf9fa;
      border: 1px solid #777;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      margin-bottom: 86px;

      &-icon {
        width: 60px;
        height: 60px;
        margin-right: 16px;
      }
    }
  }
}

.dialog-video {
  width: 1150px;
  height: 600px;
  margin: 10px auto;
}

.active {
  background: #181f99;
  color: #fff;
}

.news_pagination {
  display: flex;
  justify-content: flex-end;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.test {
  overflow: hidden;
  width: 284px;
  height: 160px;
}

.video {
  width: 844px;
  margin: 0 auto;
}
</style>
